import LocalStorage from './localStorage';
import { message } from 'antd';
import { history } from 'app/history';

export const apiUrl = process.env.REACT_APP_API_URL;
export const balanceUrl = 'https://balance.gravitipharma.com/api/V1/';
// export const apiUrl = 'https://graviti-mir-api.lexyslabs.com/api/v1';
const encodeQueryData = (data = null) => {
  if (data) {
    const ret = [];
    for (let d in data)
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return '?' + ret.join('&');
  }
  return '';
};

const getLocalToken = () => {
  const user = LocalStorage.getItem('Gravity_user');
  const authToken = user?.token;
  // Only build a Bearer header when a real token exists. Previously a logged-out user
  // (authToken === undefined) produced the literal string "Bearer undefined", which the
  // backend then tried to verify and rejected with a misleading "session expired" error.
  if (authToken) {
    return `Bearer ${authToken}`;
  } else {
    return '';
  }
};

const getLocalSessionToken = () => {
  const user = LocalStorage.getItem('Gravity_user');
  return user?.session_token || '';
};

// When a session is displaced/expired, a page that fired several requests at once would get a
// 403 on EACH one and previously showed a separate warning + redirect per request (6-7 stacked
// toasts). This guard ensures the logout handling runs exactly once until the next login.
let sessionTerminationHandled = false;
export const resetSessionTerminationGuard = () => {
  sessionTerminationHandled = false;
};
const handleSessionTermination = (data) => {
  if (!sessionTerminationHandled) {
    sessionTerminationHandled = true;
    localStorage.clear();
    message.warning({
      content:
        data?.message ||
        'You were logged out because your account was signed in on another device.',
      key: 'session_terminated'
    });
    history.push('/login');
  }
  // Stop the request chain here: returning a promise that never settles prevents each
  // individual caller from also surfacing its own error toast for this 403. The single
  // warning above is the only message the user should see. (Pages are unmounting via the
  // redirect to /login, so these dangling requests are inconsequential.)
  return new Promise(() => {});
};

const apiClient = {
  Urls: {
    apiUrl,
    signin: `${apiUrl}/user/signin`,
    signout: `${apiUrl}/user`,
    resetPassword: `${apiUrl}/users/reset-password`,
    materialList: `${apiUrl}/material`,
    document: `${apiUrl}/document`,
    weighing: `${apiUrl}/weighments`,
    damaged: `${apiUrl}/damage`,
    supplierslist: `${apiUrl}/suppliers`,
    qc: `${apiUrl}/qc`,
    lc: `${apiUrl}/lc`,
    printLable: `${apiUrl}/user`,
    vehicle: `${apiUrl}/vehicle-storage`,
    batch: `${apiUrl}/batch`,
    freeContainers: `${apiUrl}/bin`,
    dispense: `${apiUrl}/dispense`,
    container: `${apiUrl}/container`,
    wastage: `${apiUrl}/wastage`,
    sampling: `${apiUrl}/sampling`,
    stocks: `${apiUrl}/stock`,
    admin: `${apiUrl}/admin`,
    product: `${apiUrl}/product`,
    granulation: `${apiUrl}/product_granulation`,
    sifting: `${apiUrl}/shift_and_milling`,
    extraGranulation: `${apiUrl}/extra_granular`,
    blending: `${apiUrl}/blending`,
    prodSampling: `${apiUrl}/sampling_products`,
    yieldRecon: `${apiUrl}/yield_reconsiliation`,
    blendDistribution: `${apiUrl}/blend_distribution`,
    trf: `${apiUrl}/trf`,
    balance: `${balanceUrl}/balance`,
    returnQty: `${apiUrl}/returned_qty`,
    productWeighing: `${apiUrl}/prodweighing`,
    bomProdUser: `${apiUrl}/bom_prod_user`,
    bmrExecution: `${apiUrl}/bmr_exec`,
    print: `${apiUrl}`,
    batchLog: `${apiUrl}/batch_log_book`,
    audit: `${apiUrl}/audit_log`,
    transfer: `${apiUrl}/code_transfer`,
    department: `${apiUrl}/department`,
    lcBmr: `${apiUrl}/lc_bmr`,
    productMaster: `${apiUrl}/prod_master`,
    exe: `${apiUrl}/exe`,
    returnable: `${apiUrl}/returnable`,
    nonreturnable: `${apiUrl}/nonreturnable`,
    purchase: `${apiUrl}/purchase`,
    returnabledate: `${apiUrl}/returnabledate`,
    nonreturnabledate: `${apiUrl}/nonreturnabledate`,
    coldchamber: `${apiUrl}/clean`,
    wrapper: `${apiUrl}/wrap`,
    prep: `${apiUrl}/prep`,
    remstock: `${apiUrl}/remstock`,
    eqp: `${apiUrl}/eqp_integration`,
    tracker: `${apiUrl}/eq_maintainence`,
    productDetails: `${apiUrl}/prod_dispense`,
    eqp_area: `${apiUrl}/eqp_area`,
    requisition: `${apiUrl}/requisition_slip`,
    invtracker: `${apiUrl}/inv_tracker`,
    inventory: `${apiUrl}/inventory-report`,
    miscellaneous: `${apiUrl}/miscellaneous_labels`,
    licenseKey: `${apiUrl}/license`,
    AreasList: `${apiUrl}/area-name-list`,
    productVerification: `${apiUrl}/product-verification`,
    verificationTolerances: `${apiUrl}/verification-tolerances`,
    otherReports: `${apiUrl}/other-reports`,
    drumLabels: `${apiUrl}/drum-labels`,
    sieveLabels: `${apiUrl}/sieve-labels`,
    hvacFilters: `${apiUrl}/hvac-filters`,
    auditTrailConsolidated: `${apiUrl}/audit-trail-consolidated`,
    materialLabel: `${apiUrl}/material-label`
  },

  make: function (url, method, params, auth, type) {
    let headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    };

    let authHeaders = {
      Authorization: getLocalToken(),
      'X-Session-Token': getLocalSessionToken()
    };

    if (auth) {
      headers = {
        ...headers,
        ...authHeaders
      };
    }

    if (method == 'GET') {
      let queryParams = '';
      if (Object.keys(params || {}).length) {
        queryParams = encodeQueryData(params);
      }
      return fetch(url + queryParams, {
        method,
        headers
      })
        .then(async (response) => {
          const data = await response.json();
          if (
            response.status === 403 &&
            (data?.code === 'SESSION_DISPLACED' ||
              data?.code === 'SESSION_EXPIRED')
          ) {
            return handleSessionTermination(data);
          }
          return data;
        })
        .catch((e) => e);
    } else {
      return fetch(url, {
        method,
        headers: type === 'file' ? authHeaders : headers,
        body: type === 'file' ? params : JSON.stringify(params)
      })
        .then(async (response) => {
          const data = await response.json();
          if (
            response.status === 403 &&
            (data?.code === 'SESSION_DISPLACED' ||
              data?.code === 'SESSION_EXPIRED')
          ) {
            return handleSessionTermination(data);
          }
          return data;
        })
        .catch((e) => e);
    }
  },

  get: function (url, params, auth) {
    return apiClient.make(url, 'GET', params, auth);
  },

  getBlob: function (url, params, auth) {
    let headers = {};
    let authHeaders = {
      Authorization: getLocalToken(),
      'X-Session-Token': getLocalSessionToken()
    };
    if (auth) {
      headers = { ...authHeaders };
    }
    let queryParams = '';
    if (Object.keys(params || {}).length) {
      queryParams = encodeQueryData(params);
    }
    return fetch(url + queryParams, {
      method: 'GET',
      headers
    })
      .then(async (response) => {
        if (response.status === 403) {
          const data = await response.json();
          if (
            data?.code === 'SESSION_DISPLACED' ||
            data?.code === 'SESSION_EXPIRED'
          ) {
            return handleSessionTermination(data);
          }
          return data;
        }
        return response.blob();
      })
      .catch((e) => e);
  },

  post: function (url, params, auth, type) {
    return apiClient.make(url, 'POST', params, auth, type);
  },

  put: function (url, params, auth) {
    return apiClient.make(url, 'PUT', params, auth);
  },

  patch: function (url, params, auth) {
    return apiClient.make(url, 'PATCH', params, auth);
  },

  delete: function (url, params, auth) {
    return apiClient.make(url, 'DELETE', params, auth);
  }
};

export default apiClient;
